module.exports = __webpack_public_path__ + "img/xm04-ebf514.png";